module.exports = "/_next/static/images/d59e34477661228c527fec0e88cccbfa-man-holding-two-phones@0.75x.jpg.webp";